export const logos = [
    {
        name: "New Year",
        startDate: "2024-12-31 00:00:00",
        endDate: "2025-01-01 00:00:00",
        lottieFile: "/assets/Lottie/NewYear2025/purple.lottie",
        color: 'purple'
    },
    {
        name: "New Year",
        startDate: "2024-12-31 00:00:00",
        endDate: "2025-01-01 00:00:00",
        lottieFile: "/assets/Lottie/NewYear2025/white.lottie",
        color: 'white'
    },
    {
        name: "Republic Day",
        startDate: "2025-01-25 18:00:00",
        endDate: "2025-01-27 00:00:00",
        lottieFile: "/assets/Lottie/Republic2025/logo.lottie",
        color: 'white'
    },
    {
        name: "Republic Day",
        startDate: "2025-01-25 18:00:00",
        endDate: "2025-01-27 00:00:00",
        lottieFile: "/assets/Lottie/Republic2025/logo.lottie",
        color: 'purple'
    },
    {
        name: "Valentine's Day",
        startDate: "2025-02-13 18:00:00",
        endDate: "2025-02-15 00:00:00",
        lottieFile: "/assets/Lottie/Valentines2025/white.lottie",
        color: 'white'
    },
    {
        name: "Valentine's Day",
        startDate: "2025-02-13 18:00:00",
        endDate: "2025-02-15 00:00:00",
        lottieFile: "/assets/Lottie/Valentines2025/purple.lottie",
        color: 'purple'
    },
    {
        name: "Holi",
        startDate: "2025-03-13 18:00:00",
        endDate: "2025-03-15 00:00:00",
        lottieFile: "/assets/Lottie/Holi2025/logo.lottie",
        color: 'white'
    },
    {
        name: "Holi",
        startDate: "2025-03-13 18:00:00",
        endDate: "2025-03-15 00:00:00",
        lottieFile: "/assets/Lottie/Holi2025/logo.lottie",
        color: 'purple'
    },
    {
        name: "Labour Day",
        startDate: "2025-04-29 18:00:00",
        endDate: "2025-05-02 00:00:00",
        lottieFile: "/assets/Lottie/LabourDay2025/white.lottie",
        color: 'white'
    },
    {
        name: "Labour Day",
        startDate: "2025-04-30 18:00:00",
        endDate: "2025-05-02 00:00:00",
        lottieFile: "/assets/Lottie/LabourDay2025/purple.lottie",
        color: 'purple'
    },
    {
        name: "Eid Mubarak",
        startDate: "2025-04-06 22:00:00",
        endDate: "2025-06-08 02:00:00",
        lottieFile: "/assets/Lottie/LabourDay2025/eidWhite.lottie",
        color: 'white'
    },
    {
        name: "Eid Mubarak",
        startDate: "2025-06-06 22:00:00",
        endDate: "2025-06-08 02:00:00",
        lottieFile: "/assets/Lottie/LabourDay2025/eidPurple.lottie",
        color: 'purple'
    },
];
